<template>
  <div id="h5-player">
  </div>
</template>

<script>
export default {
  data() {
    return {
      instance: null,
    };
  },
  props: [
  ],
  watch: {

  },
  methods: {
    playLive() {
      this.instance.play();
    },
  },
  mounted() {
    /* eslint-disable */
    const teacherH5Player = window.player = BJY.H5Player.create({
      element: $('#h5-player'),
      useBplayer: true, // 为 true 时，即开启 低延时播放，安卓和iOS 延时 低至500-2000ms；未开启时，安卓延时 4000ms，iOS 延时 8000ms
      preLoad: true, // 是否预加载，usBplayer 配置为true 时，建议开启
      showControls: false,
      poster: '',
      // customCoverImg:'https://oss1.iqihang.com/oss/img/2021/12/27/1640585571557000959.png', //设置自定义背景图
    });
    this.instance = teacherH5Player;
  },
  beforeDestroy() {
    this.instance && this.instance.destroy();
  },
};
</script>

<style lang='scss'>
#h5-player {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100% !important;
  font-size: 32px;
  background: #000;
    // 隐藏一些默认样式
    #wasmplayer-webrtcMixUser {
      background: #fff !important;
    }
    .bjy-player-mask {
      display: none;
    }
    .bjy-player-status-text {
      display: none;
    }
  video {
    object-fit: cover;
  }
}
#btn-play {
  position: absolute;
  bottom: -100px;
  z-index: 1111;
}
</style>
